/**
 * Konverterar GeoJSON features till layer format
 * Används för att konvertera selectedAreas (features) till formatet som behövs för layerSelection
 * 
 * @param {Array} selectedAreas - Array av GeoJSON features
 * @returns {Object} Layer format { aregion, county, municipality, postalCodes, localities }
 */
export function convertFeaturesToLayerFormat(selectedAreas) {
    if (!selectedAreas || !Array.isArray(selectedAreas) || selectedAreas.length === 0) {
        return {
            aregion: [],
            county: [],
            municipality: [],
            postalCodes: [],
            localities: []
        };
    }

    const result = {
        aregion: [],
        county: [],
        municipality: [],
        postalCodes: [],
        localities: []
    };

    selectedAreas.forEach(feature => {
        if (!feature || !feature.properties) {
            return;
        }

        const type = feature.properties.type;
        const code = feature.properties.code;
        const name = feature.properties.name;

        switch(type) {
            case 'zip1':
                if (name) {
                    result.postalCodes.push(`${name}0000-${name}9999`);
                }
                break;
            case 'zip2':
                if (name) {
                    result.postalCodes.push(`${name}000-${name}999`);
                }
                break;
            case 'zip3':
                if (name) {
                    result.postalCodes.push(`${name}00-${name}99`);
                }
                break;
            case 'zip5':
                if (name) {
                    result.postalCodes.push(name);
                }
                break;
            case 'county':
                if (code) {
                    result.county.push(code);
                }
                break;
            case 'municipality':
                if (code) {
                    result.municipality.push(code);
                }
                break;
            case 'aregion':
                if (code) {
                    result.aregion.push(code);
                }
                break;
            case 'postalcity':
                if (code) {
                    result.localities.push(code);
                }
                break;
            default:
                break;
        }
    });

    return result;
}

